import { render, staticRenderFns } from "./SimplePage.vue?vue&type=template&id=264288ae&scoped=true&"
import script from "./SimplePage.vue?vue&type=script&lang=ts&"
export * from "./SimplePage.vue?vue&type=script&lang=ts&"
import style0 from "./SimplePage.vue?vue&type=style&index=0&id=264288ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264288ae",
  null
  
)

export default component.exports